import React, { FC } from 'react';

import { useViewType, ViewType } from '@eika/hooks';

import ExpandTableDesktop from './ExpandTableDesktop';
import ExpandTableMobile from './ExpandTableMobile';

interface ExpandTableSubRow {
    id: string;
    rowElements: string[];
}

export interface ExpandTableRow {
    id: string;
    rowElements: string[];
    subTable: ExpandTableSubRow[];
}

export interface ExpandTableColumn {
    id: string;
    label: string;
    boldColumn?: boolean;
}

export interface ExpandTableProps {
    id: string;
    tableRows: ExpandTableRow[];
    tableHeader: ExpandTableColumn[];
    className?: string;
}

const ExpandTable: FC<ExpandTableProps> = ({ id, tableHeader, tableRows, className }) => {
    const viewType = useViewType();

    if (viewType === ViewType.mobile) {
        return <ExpandTableMobile id={id} tableRows={tableRows} tableHeader={tableHeader} className={className} />;
    }

    return <ExpandTableDesktop id={id} tableHeader={tableHeader} tableRows={tableRows} className={className} />;
};

export default ExpandTable;
